import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Search, User, LogOut, ChevronDown } from "lucide-react";
import { getJWTDecoded } from "../../../utils/userUtils";

const messageWarning1 =
  "Non è possibile aggiornare perché il formato della mail esiste già";
const messageWarning2 =
  "Non è possibile aggiornare perché i parametri inseriti sono già stati salvati";

const Navbar = () => {
  const [isAvatarMenu, setIsAvatarMenu] = useState<boolean>(false);
  const userInfo = getJWTDecoded();

  return (
    <nav className="fixed top-0 right-0 z-10 w-full bg-[#0c1d46]  shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo Section */}
          {/* <div className="flex-shrink-0">
            <Link to="/" className="text-white font-bold text-xl">
              Logo
            </Link>
          </div> */}

          {/* Search Bar - Commented but styled for future use */}
          {/* <div className="hidden md:block flex-1 max-w-md mx-4">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="search"
                className="block w-full pl-10 pr-3 py-2 border border-transparent rounded-full 
                         bg-white/10 text-white placeholder-gray-300
                         focus:outline-none focus:bg-white/20 focus:ring-2 focus:ring-light-blue
                         text-sm transition-all duration-300"
                placeholder="Search..."
              />
            </div>
          </div> */}

          {/* User Menu */}
          <div className="relative ml-auto">
            <motion.button
              className="flex items-center space-x-3 text-white hover:bg-white/10 
                       rounded-full py-2 px-3 transition-all duration-300"
              onClick={() => setIsAvatarMenu(!isAvatarMenu)}
              whileTap={{ scale: 0.97 }}
            >
              <div className="relative">
                <img
                  className="w-8 h-8 rounded-full border-2 border-light-blue object-cover"
                  src="https://aui.atlassian.com/aui/latest/docs/images/avatar-person.svg"
                  alt="user photo"
                />
                <div className="absolute bottom-0 right-0 h-3 w-3 bg-green-400 rounded-full border-2 border-dark-blue"></div>
              </div>
              <div className="hidden md:flex items-center space-x-2">
                <span className="text-sm font-medium">{userInfo.name}</span>
                <ChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${
                    isAvatarMenu ? "rotate-180" : ""
                  }`}
                />
              </div>
            </motion.button>

            <AnimatePresence>
              {isAvatarMenu && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  transition={{ duration: 0.2 }}
                  className="absolute right-0 mt-2 w-52 origin-top-right rounded-xl bg-white shadow-lg 
                           ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 z-50"
                >
                  <div className="px-4 py-3">
                    <p className="text-sm text-gray-500">Signed in as</p>
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {userInfo.email}
                    </p>
                  </div>

                  <div className="py-2">
                    <div className="px-4 py-2">
                      <div className="flex items-center space-x-3">
                        <User className="w-5 h-5 text-gray-400" />
                        <span className="text-sm text-gray-700">Profile</span>
                      </div>
                    </div>
                  </div>

                  <div className="py-2">
                    <Link
                      to="/"
                      onClick={() => {
                        localStorage.clear();
                        window.location.assign("/");
                      }}
                      className="px-4 py-2 flex items-center space-x-3 text-sm text-red-600 
                               hover:bg-red-50 w-full transition-colors duration-200"
                    >
                      <LogOut className="w-5 h-5" />
                      <span className="font-medium">Sign out</span>
                    </Link>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>

      {/* Mobile Search - Commented but styled for future use */}
      {/* <div className="md:hidden px-4 pb-4">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="search"
            className="block w-full pl-10 pr-3 py-2 border border-transparent rounded-full 
                     bg-white/10 text-white placeholder-gray-300
                     focus:outline-none focus:bg-white/20 focus:ring-2 focus:ring-light-blue
                     text-sm transition-all duration-300"
            placeholder="Search..."
          />
        </div>
      </div> */}
    </nav>
  );
};

export default Navbar;
